<template>
  <v-layout>
    <v-flex xs12>
      <!-- <dashboard-graph-loading v-if="loading"></dashboard-graph-loading> -->
      <apexchart
        ref="BotAnswerReport"
        type="bar"
        height="auto"
        width="100%"
        :options="options"
        :series="series"
      ></apexchart>
    </v-flex>
  </v-layout>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import DashboardGraphLoading from './DashboardGraphLoading'

export default {
  props: ['selectedDate', 'data', 'loading'],
  data() {
    return {}
  },
  components: {
    apexchart: VueApexCharts,
    DashboardGraphLoading
  },
  mounted() {},
  computed: {
    options() {
      return {
        chart: {
          id: 'answer-bot-chart'
        },
        colors: ['#ff706b', '#9e9e9e'],
        dataLabels: {
          style: {
            fontSize: '14px',
            fontWeight: 'bold',
            colors: ['#000']
          }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            distributed: true
          }
        },
        xaxis: {
          categories: ['บอทตอบได้', 'บอทตอบไม่ได้']
        }
      }
    },
    series() {
      return [
        {
          name: 'Total',
          data: [this.data.bot_answer, this.data.bot_not_answer]
        }
      ]
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/AnswerBotGraph.vue